// GET /{id} and GET /{id}/subscriptions both return the same `summary` block
// (confirmed in Postman); either source works.
export const getIpoSummary = (ipoDetail, subscriptionsSummary) =>
  ipoDetail?.summary || subscriptionsSummary || null;

export const getIpoSubscriptionCount = (ipoDetail, subscriptionsSummary) => {
  const summary = getIpoSummary(ipoDetail, subscriptionsSummary);
  return Number(summary?.subscriptions_count ?? 0);
};

// Statuses at or past "closed" — allotment is only accepted from here on.
export const IPO_ALLOTTABLE_STATUSES = ["closed", "allotment"];

// The offer can be listed once results have been applied; the backend
// refuses a second go-live so "listed" is excluded.
export const IPO_LISTABLE_STATUSES = ["closed", "allotment"];

export const isIpoTerminal = (status) =>
  ["listed", "cancelled", "withdrawn"].includes(status);
